export default {
  title: 'Report team vendite',
  fields: {
    name: 'Nome',
    area: 'Area',
    signed: 'Firmati',
    live: 'Live',
  },
  buttons: {
    download_report: 'Scarica report',
  },
  toasts: {
    failed_to_load_data: 'Caricamento dati non riuscito, aggiorna la pagina',
  },
};
